function NetworkError(res) {
  if (
    (typeof res.response.message !== 'undefined' &&
      (res.response.message === 'Network Error' ||
        res.response.message === 'Request failed with status code 500' ||
        res.response.response.status === 401 ||
        res.response.response.status === 500 ||
        res.response.message === 'Request failed with status code 401')) ||
    res.response.message === 'Request failed with cache expired'
  ) {
    return '/genericerror';
  }
}

export default NetworkError;
